// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from HorizontalScroll.module.scss   */
.HorizontalScroll-module-Root_U-1 {
  position: relative;
  overflow: hidden; }

.HorizontalScroll-module-Container_1Gw {
  overflow: hidden; }

.HorizontalScroll-module-Wrap_2y8 {
  position: relative;
  z-index: 1;
  /* stylelint-disable declaration-no-important  */
  overflow: -moz-scrollbars-none !important;
  /* stylelint-enable */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  -ms-overflow-style: none;
  /* stylelint-disable-next-line */
  scrollbar-width: none; }

.HorizontalScroll-module-Wrap_2y8,
.HorizontalScroll-module-ItemsWrap_jFk {
  margin-top: -20px;
  margin-bottom: -20px;
  padding-top: 20px;
  padding-bottom: 20px; }

.HorizontalScroll-module-Wrap_2y8::-webkit-scrollbar {
  display: none; }

.HorizontalScroll-module-hasArrows_31Q::after,
.HorizontalScroll-module-hasArrows_31Q::before {
  position: absolute;
  z-index: 4;
  top: -6px;
  bottom: -6px;
  width: 2px;
  background-color: rgba(0, 0, 0, 0.15); }

.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_both_144::after,
.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_right_2M1::after {
  right: 0;
  content: ''; }

.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_both_144::before,
.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_left_3eI::before {
  left: 0;
  content: ''; }

.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-Container_1Gw,
.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-Wrap_2y8,
.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-ItemsWrap_jFk {
  margin-right: -15px;
  margin-left: -15px;
  padding-right: 15px;
  padding-left: 15px; }

.HorizontalScroll-module-sameHeight_21a .HorizontalScroll-module-ItemsWrap_jFk {
  display: inline-flex; }

.HorizontalScroll-module-sameHeight_21a .HorizontalScroll-module-ItemsWrap_jFk .HorizontalScroll-module-Item_A-A {
  flex-shrink: 0; }

.HorizontalScroll-module-noGap_7qm .HorizontalScroll-module-Wrap_2y8,
.HorizontalScroll-module-noGap_7qm .HorizontalScroll-module-ItemsWrap_jFk {
  margin-right: 0;
  margin-left: 0;
  padding-right: 0;
  padding-left: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/HorizontalScroll/HorizontalScroll.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,gDAAgD;EAChD,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,qBAAqB,EAAE;;AAEzB;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB,EAAE;;AAExB;EACE,aAAa,EAAE;;AAEjB;;EAEE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,qCAAqC,EAAE;;AAEzC;;EAEE,QAAQ;EACR,WAAW,EAAE;;AAEf;;EAEE,OAAO;EACP,WAAW,EAAE;;AAEf;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe,EAAE","sourcesContent":["/*  imported from HorizontalScroll.module.scss   */\n.HorizontalScroll-module-Root_U-1 {\n  position: relative;\n  overflow: hidden; }\n\n.HorizontalScroll-module-Container_1Gw {\n  overflow: hidden; }\n\n.HorizontalScroll-module-Wrap_2y8 {\n  position: relative;\n  z-index: 1;\n  /* stylelint-disable declaration-no-important  */\n  overflow: -moz-scrollbars-none !important;\n  /* stylelint-enable */\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  white-space: nowrap;\n  -ms-overflow-style: none;\n  /* stylelint-disable-next-line */\n  scrollbar-width: none; }\n\n.HorizontalScroll-module-Wrap_2y8,\n.HorizontalScroll-module-ItemsWrap_jFk {\n  margin-top: -20px;\n  margin-bottom: -20px;\n  padding-top: 20px;\n  padding-bottom: 20px; }\n\n.HorizontalScroll-module-Wrap_2y8::-webkit-scrollbar {\n  display: none; }\n\n.HorizontalScroll-module-hasArrows_31Q::after,\n.HorizontalScroll-module-hasArrows_31Q::before {\n  position: absolute;\n  z-index: 4;\n  top: -6px;\n  bottom: -6px;\n  width: 2px;\n  background-color: rgba(0, 0, 0, 0.15); }\n\n.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_both_144::after,\n.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_right_2M1::after {\n  right: 0;\n  content: ''; }\n\n.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_both_144::before,\n.HorizontalScroll-module-arrowLine_36V.HorizontalScroll-module-hasArrows_31Q.HorizontalScroll-module-scrollDirection_left_3eI::before {\n  left: 0;\n  content: ''; }\n\n.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-Container_1Gw,\n.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-Wrap_2y8,\n.HorizontalScroll-module-widthFull_29z .HorizontalScroll-module-ItemsWrap_jFk {\n  margin-right: -15px;\n  margin-left: -15px;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.HorizontalScroll-module-sameHeight_21a .HorizontalScroll-module-ItemsWrap_jFk {\n  display: inline-flex; }\n\n.HorizontalScroll-module-sameHeight_21a .HorizontalScroll-module-ItemsWrap_jFk .HorizontalScroll-module-Item_A-A {\n  flex-shrink: 0; }\n\n.HorizontalScroll-module-noGap_7qm .HorizontalScroll-module-Wrap_2y8,\n.HorizontalScroll-module-noGap_7qm .HorizontalScroll-module-ItemsWrap_jFk {\n  margin-right: 0;\n  margin-left: 0;\n  padding-right: 0;\n  padding-left: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
